export default function numberWithCommas(x, fixed = 0) {
  return parseFloat(x.toFixed(fixed)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
